module.exports = __webpack_public_path__ + "static/media/cq_editor_lista_numerata.62758816.svg";